import { Grid, TextField } from '@material-ui/core'
import styled from 'styled-components'

import Spinner from '../../../Spinner'

import CashIcon from '../../../../img/rewards/cash.inline.svg'

export const Header = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 1rem;
  justify-content: space-between;
  button {
    color: ${({ theme }) => theme.colors.text.secondary};
    padding: 0;
  }
  .MuiTypography-h5 {
    margin-bottom: 0;
  }
  @media (min-width: 768px) {
    margin-bottom: 1.25rem;
  }
`

export const TotalBalance = styled.div`
  width: 100%;
`

export const TotalBalanceText = styled.h4`
  margin: 0 0 30px 0;
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-size: 13px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.primary};
`

export const CashbackLabel = styled.span<{ $cashBackOnSpentCommissions: number }>`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-weight: 500;
  font-size: 12px;
  color: ${({ theme, $cashBackOnSpentCommissions }) =>
    $cashBackOnSpentCommissions > 0
      ? theme.colors.blackPearlBlue.shade500
      : theme.colors.coolGray.cool600};
  margin-top: 20px;
`

export const TotalBalanceAmount = styled.span`
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  font-size: 14px;
  color: #696969;
  margin-left: 0.3em;
  font-weight: 400;
  @media (min-width: 425px) {
    font-weight: 700;
  }
`

export const CashbackAmount = styled.span`
  font-size: 14px;
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  font-weight: 400;
  color: #696969;
`

export const RewardsIcon = styled(CashIcon)`
  vertical-align: -0.3em;
  margin-right: 8px;
`

export const RewardsField = styled(TextField)`
  max-width: 144px;
  flex: 1;
  margin-bottom: 0;
  .MuiFormLabel-root {
    color: ${({ theme }) => theme.colors.coolGray.cool600};
    font-size: 12px;
    &.Mui-focused {
      color: ${({ theme }) => theme.colors.coolGray.cool600};
    }
  }
  .MuiInputAdornment-positionStart {
    margin-right: 2px;
  }
  .MuiInputLabel-filled {
    transform: translate(12px, 10px) scale(0.9);
  }
`

export const MinimumChargeAlertContainer = styled.div`
  margin-top: 40px;
`

export const RewardsContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  margin-bottom: 8px;
  margin-left: 10px;
  input,
  .MuiTypography-body1 {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.text.primary};
    line-height: 1;
  }
  @media (min-width: 425px) {
    flex: 1;
    margin-bottom: 40px;
    margin-left: 20px;
  }
`

export const Container = styled(Grid)`
  margin-bottom: 0;
`

export const LeanSpinner = styled(Spinner)`
  padding-top: 0;
`

export const Right = styled.div`
  display: flex;
  margin-top: 30px;
  margin-right: 50px;
`

export const Left = styled.div`
  display: flex;
  align-items: center;
`
